import barcode from 'assets/UDI_barcode.svg';
import { Stack } from 'common/ui/Layout';
import Colors from 'styles/colors';
import Spacing from 'styles/spacings';
import { rootTheme } from 'theme/rootTheme';

export const Barcode = (): React.ReactElement => {
  return (
    <Stack>
      <img
        src={barcode}
        style={{
          width: '100%',
          padding: Spacing.large,
          backgroundColor: Colors.white,
          borderRadius: rootTheme.radius.xs,
        }}
        alt="UDI Barcode"
      />
    </Stack>
  );
};
